/*
defines appearance of wiki (large text) nodes
*/

import NodeView from './node';
import {getTextSelection} from '../utilities/utilities';

/**
 * Represents a view for a wiki node
 */
export default class WikiNodeView extends NodeView {
    /**
     * makes a new wiki node view given a model node and a position
     * @param {WikiNode} node the model wiki node to use
     * @param {number} [x] (optional) position to start at
     * @param {number} [y] (optional) position to start at
     */
    constructor(node, x = 0, y = 0) {
        super(node, x, y);
        this.type = 'wiki';
        // this.text = this.node.text!==undefined ? this.node.text :"looking...";

        this.defineUpdateCallback();
        this.updateCallback();

        this.initTooltip();
    }

    /**
     * defines the function to call when the api updates
     */
    defineUpdateCallback() {
        // runs when the API is updated for this node
        this.updateCallback = () => {
            if (this.node.isEmpty()) return;
            let text = this.node.getText() || "looking...";

            this.selection =
                NodeView.container.select('.node-' + this.id);
            this.selection.selectAll("*").remove();
            this.selection = 
                NodeView.container.select('.node-' + this.id)
                    .append("xhtml:body")
                    .attr('xmlns', 'http://www.w3.org/1999/xhtml')
                    .style('position', 'relative')
                    .html(`<span class="div">${text}</span>`)
                    .attr('width', this.width)
                    .attr('height', this.height);
        };
    }

    /**
     * gets the svg object to use for this view node
     * @return {SVGElement} the object into which we inject wiki html
     */
    append() {
        let fo = document.createElementNS('http://www.w3.org/2000/svg', 'foreignObject');
        fo.setAttribute('width', this.width);
        fo.setAttribute('height', this.height);
        let body = document.createElement('body');
        body.setAttribute('xmlns', 'http://www.w3.org/1999/xhtml');
        body.style.position = 'relative';
        let span = document.createElement('span');
        span.innerHTML = this.node.getText() || "looking...";
        span.classList = 'text';
        body.appendChild(span);
        fo.appendChild(body);
        return fo;
    }

    /**
     * given an index, returns the color of the text
     * @param {number} i the id of this node
     * @return {string} the color to fill this node /its text with
     */
    fill(i) {
        return 'black';
    }

    /**
     * highlights whatever is selected in this node.
     * not working currently.
     */
    highlight() {
        selected = getTextSelection();
        if (selected === '') return;
        this.selection.html(this.selection.html().replace(selected, `<span class=highlighted>${selected}</span>`));
    }
}
